import React from 'react'
import { ColumnStartOrder, ColumnName, ColumnNoc, ColumnRank, ColumnResult, ColumnStartTime, ColumnExpander, ColumnHorse, ColumnAthleteHorse } from "components/common/TableColumns"
import { ColumnRemarks } from '../common/TableColumns';
import Label from 'components/general/Label';
import Horse from 'components/presentation/Horse';


export function ridingColumns(isFinished) {
    return [
        ColumnRank({hasRankEqual: true, disableSort: isFinished}),
        ColumnStartOrder({headerClassName: 'text-end w-5 mirs-break-line',}),
        ColumnStartTime({headerClassName: 'text-end w-10 mirs-break-line', className:'text-end'}),
        ColumnNoc({ disableSort: isFinished}),
        ColumnName({ disableSort: isFinished}),
        ColumnAthleteHorse({disableSort:true}),
        ColumnHorse({disableSort:true}),
        ColumnHorseTeam({disableSort:true}),
        ColumnResult({label:"HeaderRidingPoints", headerClassName: "text-end w-5 mirs-break-line", hideIrm: true}),
        ColumnRemarks({}),
        ColumnExpander({})
    ];
}

export function ColumnHorseTeam({
    disableSort = false,
    className = 'text-start',
    headerClassName = 'text-start',
    label = 'HeaderHorse',
    remove = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => (props?.horse?.name?.toUpperCase()),
            id: 'HorseTeam',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original;
                return (<Horse {...row?.teamAthletes[0]?.horse} />);
            }
        }
    )
}

